import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let caseExample = `read -rp "Action: " action

case "$action" in
    start|up)
        echo "starting"
        ;;
    stop|down)
        echo "stopping"
        ;;
    status)
        echo "checking status"
        ;&                 # fall through into the next pattern unconditionally
    verbose-status)
        echo "printing extra detail"
        ;;
    *)
        echo "unknown action: $action"
        ;;
esac`

let extglobExample = `shopt -s extglob

for f in *.@(jpg|jpeg|png); do
    echo "image: $f"
done

# !(pattern) - anything that does NOT match
rm !(*.log)`

export default function PatternMatching() {
    return (
        <div className={globalStyles.article}>
            <h1>Pattern matching & case</h1>
            <p>Beyond the basic <code>case ... esac</code> shown on the <b>Loops</b> page, bash supports
                alternation, fall-through, and extended globs for more expressive matching.</p>

            <h3>Multiple patterns & fall-through</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Terminator</th>
                        <th>Behavior</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>;;</code></td>
                        <td>Stop after this branch (the usual case)</td>
                    </tr>
                    <tr>
                        <td><code>;&amp;</code></td>
                        <td>Fall through and execute the next branch unconditionally</td>
                    </tr>
                    <tr>
                        <td><code>;;&amp;</code></td>
                        <td>Keep testing subsequent patterns instead of stopping</td>
                    </tr>
                    <tr>
                        <td><code>a|b)</code></td>
                        <td>Match either pattern <code>a</code> or <code>b</code></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <SyntaxHighlighter
                children={caseExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <h3>Extended globbing</h3>
            <p><code>shopt -s extglob</code> unlocks regex-like patterns for filename matching, both in
                globs and inside <code>case</code>/<code>[[ ]]</code>.</p>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '400px'}}>
                    <thead>
                    <tr>
                        <th>Pattern</th>
                        <th>Matches</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>@(a|b)</code></td>
                        <td>Exactly one of the patterns</td>
                    </tr>
                    <tr>
                        <td><code>?(a|b)</code></td>
                        <td>Zero or one occurrence</td>
                    </tr>
                    <tr>
                        <td><code>*(a|b)</code></td>
                        <td>Zero or more occurrences</td>
                    </tr>
                    <tr>
                        <td><code>+(a|b)</code></td>
                        <td>One or more occurrences</td>
                    </tr>
                    <tr>
                        <td><code>!(a|b)</code></td>
                        <td>Anything except the patterns</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <SyntaxHighlighter
                children={extglobExample}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}
